export const supportedLanguages = ['en', 'es', 'pt'];
